<template>
  <div class="bg-gray">
    <navigation-bar />
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12" style="padding-top:20px;">
            <div class="row">
              <div class="col-xs-12 col-sm-12 text-left">
                <div class="row">
                  <div class="col-sm-12">
                    <h1 style="float:left;">Listing Details</h1>
                  </div>
                </div>
                <div class="row">

                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="field in store.state.listing.fields" :key="field.id">
                        <td>
                          {{field.fieldName}}
                        </td>
                        <td>
                          {{getValue(field)}}
                        </td>
                      </tr>
                      <tr>
                        <td>Price</td>
                        <td>
                          <span v-if="store.state.listing.price != 'free'"></span>
                          ${{store.state.listing.price}}</td>
                      </tr>
                      <tr>
                        <td>
                          City
                        </td>
                        <td colspan="2">
                          {{store.state.listing.city}}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          State
                        </td>
                        <td colspan="2">
                          {{store.state.listing.state}}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <h3 style="margin-left:10px">Locations:</h3>
                  <table class="table table-striped">
                    <thead>
                      <tr>
                        <th>State</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="cityState in store.state.listing.cityStates" :key="cityState.id">
                        <td>
                          {{cityState.state}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
            <br>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '../nav/NavigationBar'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import ListingDetailsStore from './ListingDetailsStore'
import AccountSessionUtils from './AccountSessionUtils'


export default {
  name: 'ListingDetails',
  components: {
    NavigationBar,
    DashboardFooter
  },
  data () {
    return {
      nav: Navigator,
      store: ListingDetailsStore,
      accountUtils: AccountSessionUtils,
      utils: Utils
    }
  },
  mounted () {
    this.store.reset()
    if(!this.$route.params.listingId){
      this.$toasted.show('Listing not found', { type: 'error', duration: 2500 })
      return
    }

    this.store.state.listingId = this.$route.params.listingId

    this.accountUtils.authorize((userId) => {
      this.store.state.currentUserId = userId;
      if(userId == 0){
        this.nav.goLogin(this,"MyListings")
        return
      }
      this.store.getListing(data => {},err => {})
      //get listing details
    },(err) => {
      this.$toasted.show(err, { type: 'error', duration: 2500 })
    }, () => {
        this.nav.goMaintenance(this)
      })
  },
  methods: {
    getValue(field){
      if(field.fieldType == 'Date'){
        return this.utils.formatDate(field.value)
      }else{
        return field.value
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/ListingDetails.vue